module.exports = __webpack_public_path__ + "static/img/bbc-img.bf9378f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/bbc-img.png
// module id = 1074
// module chunks = 1